import { Component, OnInit } from '@angular/core';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';

@Component({
  selector: 'app-procurement-code',
  templateUrl: './procurement-code.component.html',
  styleUrls: ['./procurement-code.component.scss']
})
export class ProcurementCodeComponent implements OnInit {

  constructor(public userUtilsService:UserUtilService) { }

  ngOnInit(): void {
  }

}
